export default __webpack_public_path__ + "static/media/(4).433a94df.jpeg";